import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { USERS } from '../constants'
import { UserFormInput } from '../types'

const updateUser = async ({
  form,
  id,
}: {
  form: UserFormInput
  id: number
}) => {
  await fetchAPI({
    method: 'put',
    path: `/users/${id}`,
    data: form,
  })
}

export const useUpdateUser = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateUser, {
    onSuccess: async () => {
      await queryClient.refetchQueries([USERS])

      toast({
        description: t('views.admin.users.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
